import { render, staticRenderFns } from "./SettingsShare.vue?vue&type=template&id=9c22957a&scoped=true&"
import script from "./SettingsShare.vue?vue&type=script&lang=js&"
export * from "./SettingsShare.vue?vue&type=script&lang=js&"
import style0 from "./SettingsShare.vue?vue&type=style&index=0&id=9c22957a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c22957a",
  null
  
)

export default component.exports